import React, {useState,useEffect} from 'react'

import {defaultAccount, IAccount} from './MyAccountModel'
import companyLogo from './Avision_Logo.png';
import {db, storage} from './../firebase';
import './../style.css';
import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
import {Routes, Route, useNavigate} from 'react-router-dom';
import axios from 'axios';
import liff from '@line/liff';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  setDoc ,
} from "firebase/firestore";
import * as moment from 'moment'
import successlogo from './correct.png';
import failedlogo from './failed.png';
import loadingicon from './load-icon.png';
import Popup from './../Popup';

export function Confirmdata() {
  const usersCollectionRef = collection(db, "Member");
  const [ note, setNote ] = useState("");
  const [data, setData] = useState<IAccount>(defaultAccount)
  //const [hasError, setHasError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLoading, setIsOpenLoading] = useState(false);
  const navigate = useNavigate();
  const connectionweb = JSON.parse(""+window.sessionStorage.getItem("connection"));

  const togglePopupLoading = () => {
    setIsOpenLoading(!isOpenLoading);
  }
  function popupLoading() {
    setIsOpenLoading(!isOpenLoading);
  }
  function checkcluburl(url:any)
  {
      const encoded = encodeURIComponent(url);
      return  encoded;
  }



  const handleClickNotconfirm = async () => {
   popupLoading()
    const databc = JSON.parse(""+confirmdatasuc);
    const createdata = databc.value[0];
    // confirmdata
    //checked data member bc
      //send save data bc
      let clubcode = window.sessionStorage.getItem('Club_Code');
      let clubcodeconvert =""+clubcode;
      let linedata = window.sessionStorage.getItem('linedata');
      let linedataconvert =""+linedata;
      let otpsmstobc = window.sessionStorage.getItem('OTPSMS');
      let otpsmsconverttobc= ""+otpsmstobc;
      const objsmstobc = JSON.parse(otpsmsconverttobc);
      const user = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));

      console.log("objsmstobc",objsmstobc);

      var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Create_Update_Member;
      var myHeadersotpUsage = new Headers();
      myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
      myHeadersotpUsage.append("Content-Type", "application/json");
      if (otpsmstobc) {
        console.log("OTP");
        console.log("objsmstobc.consent2",objsmstobc.consent2);

        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var newdate = year + "-" + month + "-" + day;
        var raw = JSON.stringify({
                      "memberAccountNo": createdata.memberAccountNo,
                      "clubCode": clubcodeconvert,//*
                      "schemeCode": createdata.memberScheme,
                      "mobileNo":  objsmstobc.telephone,//*
                      "lineUserId": linedataconvert, //*
                      "firstName": objsmstobc.username,//*
                      "lastName": objsmstobc.lastname,//*
                      "dateOfBirth": "0001-01-01",
                      "sex": "1",
                      "citizenID": "",
                      "emailAddress": "",
                      //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      referalMobileNo: objsmstobc.referalMobileNo,
                      //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      "address1": "",
                      "address2": "",
                      "city": "",
                      "county": "",
                      "postCode": "",
                      "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?"Yes":"No":(objsmstobc.consent1==false)?"No":"",
                      "dateConsent1": (String(objsmstobc.consent1)==="")?"0001-01-01":newdate,
                      "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?"Yes":"No":(objsmstobc.consent2==false)?"No":"",
                      "dateConsent2": (String(objsmstobc.consent2)==="")?"0001-01-01":newdate,
                      "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?"Yes":"No":(objsmstobc.consent3==false)?"No":"",
                      "dateConsent3": (String(objsmstobc.consent3)==="")?"0001-01-01":newdate,
                      "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?"Yes":"No":(objsmstobc.consent4==false)?"No":"",
                      "dateConsent4": (String(objsmstobc.consent4)==="")?"0001-01-01":newdate,
                      "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?"Yes":"No":(objsmstobc.consent5==false)?"No":"",
                      "dateConsent5": (String(objsmstobc.consent5)==="")?"0001-01-01":newdate,
                      "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?"Yes":"No":(objsmstobc.consent6==false)?"No":"",
                      "dateConsent6": (String(objsmstobc.consent6)==="")?"0001-01-01":newdate,
                      "apiStoreRegister": "",
                      "blocked": false,//*
                      "dateBlocked": "0001-01-01",
                      "apiType": "UPDATE"
                      });
      }else{
        console.log("user.consent6",user.consent6);
        const str = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
        var dateObj = new Date();
        var month = dateObj.getUTCMonth() + 1; //months from 1-12
        var day = dateObj.getUTCDate();
        var year = dateObj.getUTCFullYear();
        var newdate = year + "-" + month + "-" + day;


        var raw = JSON.stringify({
                      "memberAccountNo": createdata.memberAccountNo,
                      "clubCode": clubcodeconvert,//*
                      "schemeCode": createdata.memberScheme,
                      "mobileNo":  user.mobile_phone_no,//*
                      "lineUserId": linedataconvert, //*
                      "firstName": user.first_name,//*
                      "lastName": user.last_name,//*
                      "dateOfBirth": "0001-01-01",
                      "sex": "",
                      //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      referalMobileNo: '',
                      //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      "citizenID": "",
                      "emailAddress": "",
                      "address1": "",
                      "address2": "",
                      "city": "",
                      "county": "",
                      "postCode": "",
                      "consent1": (String(user.consent1)==="")?"":(user.consent1==true)?"Yes":(user.consent1==false)?"No":"",
                      "dateConsent1": (String(user.consent1)==="")?"0001-01-01":newdate,
                      "consent2": (String(user.consent2)==="")?"":(user.consent2==true)?"Yes":(user.consent2==false)?"No":"",
                      "dateConsent2": (String(user.consent2)==="")?"0001-01-01":newdate,
                      "consent3": (String(user.consent3)==="")?"":(user.consent3==true)?"Yes":(user.consent3==false)?"No":"",
                      "dateConsent3": (String(user.consent3)==="")?"0001-01-01":newdate,
                      "consent4": (String(user.consent4)==="")?"":(user.consent4==true)?"Yes":(user.consent4==false)?"No":"",
                      "dateConsent4": (String(user.consent4)==="")?"0001-01-01":newdate,
                      "consent5": (String(user.consent5)==="")?"":(user.consent5==true)?"Yes":(user.consent5==false)?"No":"",
                      "dateConsent5": (String(user.consent5)==="")?"0001-01-01":newdate,
                      "consent6": (String(user.consent6)==="")?"":(user.consent6==true)?"Yes":(user.consent6==false)?"No":"",
                      "dateConsent6": (String(user.consent6)==="")?"0001-01-01":newdate,
                      "apiStoreRegister": "",
                      "blocked": false,//*
                      "dateBlocked": "0001-01-01",
                      "apiType": "UPDATE"
                      });
      }

      console.log("raw",raw);

              fetch(urlotpUsage, {
                method: 'POST',
                headers: myHeadersotpUsage,
                body: raw,
                redirect: 'follow'
              })
              .then(response => response.text())
              .then(data => {
                console.log("data",data);
                const createdata = JSON.parse(data);
                console.log(createdata);
                if (!createdata.mobileNo) {

                  return ;
                }
                if (createdata.mobileNo) {
                  console.log("datatotfirebase bc",createdata);
                  //AVCDAPNF.005 , //AVCDAPNF.006  25/02/2025  Add Code for เพิ่ม field expires date และ expires point และ อัพเดท remaining point
                  if (otpsmstobc) {
                    var urlLicense = connectionweb[0].BC_Api_Endpoint + connectionweb[0].BC_Api_Get_Member + "?$filter=mobileNo eq '" + objsmstobc.telephone + "' and memberClub eq '" + checkcluburl(clubcodeconvert) + "'"
                  } else {
                    var urlLicense = connectionweb[0].BC_Api_Endpoint + connectionweb[0].BC_Api_Get_Member + "?$filter=mobileNo eq '" + user.mobile_phone_no + "' and memberClub eq '" + checkcluburl(clubcodeconvert) + "'"
                  }
          
                  var myHeaders = new Headers()
                  myHeaders.append( 'Authorization', authenticateUser(connectionweb[0].BC_Api_Username, connectionweb[0].BC_Api_Password))
          
                  fetch(urlLicense, {
                    method: 'GET',
                    headers: myHeaders,
                    redirect: 'follow',
                  })
                    .then((response) => response.text())
                    .then((data) => {
                      const parseData = JSON.parse(data);
                      const memberData = parseData.value[0];
                      //send save data firebase
                        const datatotfirebase ={
                          "address":  (createdata.address==undefined)?"":createdata.address,
                          "address2": (createdata.address2==undefined)?"":createdata.address2,
                          "bc_account_no": createdata.memberAccountNo,
                          "club_code": createdata.clubCode,
                          "consent1": (createdata.consent1==="")?"":(createdata.consent1=="Yes")?true:(createdata.consent1=="No")?false:"",
                          "consent1_date":createdata.dateConsent1,
                          "consent2": (createdata.consent2==="")?"":(createdata.consent2=="Yes")?true:(createdata.consent2=="No")?false:"",
                          "consent2_date": createdata.dateConsent2,
                          "consent3": (createdata.consent3==="")?"":(createdata.consent3=="Yes")?true:(createdata.consent3=="No")?false:"",
                          "consent3_date": createdata.dateConsent3,
                          "consent4": (createdata.consent4==="")?"":(createdata.consent4=="Yes")?true:(createdata.consent4=="No")?false:"",
                          "consent4_date": createdata.dateConsent4,
                          "consent5": (createdata.consent5==="")?"":(createdata.consent5=="Yes")?true:(createdata.consent5=="No")?false:"",
                          "consent5_date": createdata.dateConsent5,
                          "consent6": (createdata.consent6==="")?"":(createdata.consent6=="Yes")?true:(createdata.consent6=="No")?false:"",
                          "consent6_date": createdata.dateConsent6,
                          "country": createdata.county,
                          "city": createdata.city,
                          "date_of_birth": createdata.dateOfBirth,
                          "email_address": createdata.emailAddress,
                          "first_name": createdata.firstName,
                          "id_card_no": createdata.citizenID,
                          //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                          "nearlyExpireDate": memberData.nearlyExpireDate,
                          "nearlyExpirePoint": memberData.nearlyExpirePoint,
                          //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
                          "last_name": createdata.lastName,
                          "line_user_id":  createdata.lineUserId,
                          "mobile_phone_no": createdata.mobileNo,
                          "post_code": createdata.postCode,
                          "scheme": createdata.schemeCode,
                          "scheme_code": createdata.schemeCode,
                          "sex": createdata.sex,
                          //AVCDAPNF.006  25/02/2025  Add Code for อัพเดท remaining point
                          "ramianing_point": memberData.totalRemainingPoints,
                          // "ramianing_point":"0",
                          //C-AVCDAPNF.006  25/02/2025  Add Code for อัพเดท remaining point
                          "confirmdata":true,
                          "checkTamp":false,
                                    };

                              console.log("datatotfirebase",datatotfirebase);
                              const idfirebase=datatotfirebase.club_code+"_"+datatotfirebase.line_user_id;
                              const userDoc = doc(db, "Member",idfirebase);
                                 const newFields =  datatotfirebase;
                                  updateDoc(userDoc,newFields );
                                  window.sessionStorage.setItem("Confirmdata","No");
                                  sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                                  setIsOpenLoading(false);
                                  setTimeout(() => {
                                    //AVCDAPNF.002  24/02/2025  Add Code for navigate ไปหน้า homepage
                                    navigate('/homepage')
                                    // navigate('/createMember');
                                    //C-AVCDAPNF.002  24/02/2025  Add Code for navigate ไปหน้า homepage
                                   }, 2000);

                /*  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                  const resp =  axios.post(urlcreate,datatotfirebase,{
                       headers: {
                   "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                   }
                   })
                   .then(resp=>{
                    console.log(resp);
                    // checked data member bc
                        window.sessionStorage.setItem("Confirmdata","No");
                        setIsOpenLoading(false);
                        setTimeout(() => {
                          navigate('/login');
                         }, 2000);

                   })
                   .catch(err=> console.log(err))*/
                   //send save data firebase
                    })
                    .catch((error) => console.log(error))
                    
                    
                    //send save data firebase
                  // const datatotfirebase ={
                  //   "address":  (createdata.address==undefined)?"":createdata.address,
                  //   "address2": (createdata.address2==undefined)?"":createdata.address2,
                  //   "bc_account_no": createdata.memberAccountNo,
                  //   "club_code": createdata.clubCode,
                  //   "consent1": (createdata.consent1==="")?"":(createdata.consent1=="Yes")?true:(createdata.consent1=="No")?false:"",
                  //   "consent1_date":createdata.dateConsent1,
                  //   "consent2": (createdata.consent2==="")?"":(createdata.consent2=="Yes")?true:(createdata.consent2=="No")?false:"",
                  //   "consent2_date": createdata.dateConsent2,
                  //   "consent3": (createdata.consent3==="")?"":(createdata.consent3=="Yes")?true:(createdata.consent3=="No")?false:"",
                  //   "consent3_date": createdata.dateConsent3,
                  //   "consent4": (createdata.consent4==="")?"":(createdata.consent4=="Yes")?true:(createdata.consent4=="No")?false:"",
                  //   "consent4_date": createdata.dateConsent4,
                  //   "consent5": (createdata.consent5==="")?"":(createdata.consent5=="Yes")?true:(createdata.consent5=="No")?false:"",
                  //   "consent5_date": createdata.dateConsent5,
                  //   "consent6": (createdata.consent6==="")?"":(createdata.consent6=="Yes")?true:(createdata.consent6=="No")?false:"",
                  //   "consent6_date": createdata.dateConsent6,
                  //   "country": createdata.county,
                  //   "city": createdata.city,
                  //   "date_of_birth": createdata.dateOfBirth,
                  //   "email_address": createdata.emailAddress,
                  //   "first_name": createdata.firstName,
                  //   "id_card_no": createdata.citizenID,
                  //   "last_name": createdata.lastName,
                  //   "line_user_id":  createdata.lineUserId,
                  //   "mobile_phone_no": createdata.mobileNo,
                  //   "post_code": createdata.postCode,
                  //   "scheme": createdata.schemeCode,
                  //   "scheme_code": createdata.schemeCode,
                  //   "sex": createdata.sex,
                  //   "ramianing_point":"0",
                  //   "confirmdata":true,
                  //   "checkTamp":false,
                  //             };

                  //             console.log("datatotfirebase",datatotfirebase);
                  //             const idfirebase=datatotfirebase.club_code+"_"+datatotfirebase.line_user_id;
                  //             const userDoc = doc(db, "Member",idfirebase);
                  //                const newFields =  datatotfirebase;
                  //                 updateDoc(userDoc,newFields );
                  //                 window.sessionStorage.setItem("Confirmdata","No");
                  //                 sessionStorage.setItem("Customerdata", JSON.stringify(datatotfirebase));
                  //                 setIsOpenLoading(false);
                  //                 setTimeout(() => {
                  //                   
                  //                   navigate('/createMember');
                  //                   
                  //                  }, 2000);

                /*  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
                  const resp =  axios.post(urlcreate,datatotfirebase,{
                       headers: {
                   "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                   }
                   })
                   .then(resp=>{
                    console.log(resp);
                    // checked data member bc
                        window.sessionStorage.setItem("Confirmdata","No");
                        setIsOpenLoading(false);
                        setTimeout(() => {
                          navigate('/login');
                         }, 2000);

                   })
                   .catch(err=> console.log(err))*/
                   //send save data firebase
                  //AVCDAPNF.005 , //AVCDAPNF.006  25/02/2025  Add Code for เพิ่ม field expires date และ expires point และ อัพเดท remaining point
                }
              })
              .catch(error => console.log('error', error));
              //send save data bc





  }



  const handleClickconfirm = async () => {
      popupLoading()
    const databc = JSON.parse(""+confirmdatasuc);
    const createdata = databc.value[0];
    let clubcode = window.sessionStorage.getItem('Club_Code');
    let clubcodeconvert =""+clubcode;
    let linedata = window.sessionStorage.getItem('linedata');
    let linedataconvert =""+linedata;
    let otpsmstobc = window.sessionStorage.getItem('OTPSMS');
    let otpsmsconverttobc= ""+otpsmstobc;
    const objsmstobc = JSON.parse(otpsmsconverttobc);
    const user = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var newdate = year + "-" + month + "-" + day;
      //send save data firebase
      console.log("otpsmstobc",otpsmstobc);
    console.log('confirm brfore send', createdata);


      if (otpsmstobc) {
        var datatotfirebase ={
          "address":  createdata.address1,
          "address2": createdata.address2,
          "bc_account_no": createdata.memberAccountNo,
          "club_code": createdata.memberClub,
          "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?true:false:(objsmstobc.consent1==false)?false:"",
          "consent1_date": (objsmstobc.consent1===undefined )?"0001-01-01":newdate,
          "consent2":  (objsmstobc.consent2==true)?(objsmstobc.consent2)?true:false:(objsmstobc.consent2==false)?false:"",
          "consent2_date": (objsmstobc.consent2===undefined )?"0001-01-01":newdate,
          "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?true:false:(objsmstobc.consent3==false)?false:"",
          "consent3_date": (objsmstobc.consent3===undefined )?"0001-01-01":newdate,
          "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?true:false:(objsmstobc.consent4==false)?false:"",
          "consent4_date": (objsmstobc.consent4===undefined )?"0001-01-01":newdate,
          "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?true:false:(objsmstobc.consent5==false)?false:"",
          "consent5_date": (objsmstobc.consent5===undefined )?"0001-01-01":newdate,
          "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?true:false:(objsmstobc.consent6==false)?false:"",
          "consent6_date": (objsmstobc.consent6===undefined )?"0001-01-01":newdate,
          "country": createdata.county,
          "city": createdata.city,
          "date_of_birth": createdata.dateOfBirth,
          "email_address": createdata.emailAddress,
          "first_name": objsmstobc.username,
          "id_card_no": createdata.citizenID,
          "last_name": objsmstobc.lastname,
          "line_user_id":  linedataconvert,
          "mobile_phone_no": objsmstobc.telephone,
          //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
          "nearlyExpireDate": createdata.nearlyExpireDate,
          "nearlyExpirePoint": createdata.nearlyExpirePoint,
          //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
          "post_code": createdata.postCode,
          "scheme": createdata.memberScheme,
          "scheme_code": createdata.memberScheme,
          "sex": createdata.sex,
          "ramianing_point":createdata.totalRemainingPoints,
            "confirmdata":true,
            "checkTamp":false,
        };
        console.log("objsmstobc.consent5",typeof objsmstobc.consent5);

        var raw = JSON.stringify({
                      "memberAccountNo": createdata.memberAccountNo,
                      "clubCode": createdata.memberClub,//*
                      "schemeCode": createdata.memberScheme,
                      "mobileNo":  objsmstobc.telephone,//*
                      "lineUserId": linedataconvert, //*
                      "firstName": objsmstobc.username,//*
                      "lastName": objsmstobc.lastname,//*
                      "dateOfBirth": createdata.dateOfBirth,
                      "sex": (createdata.sex=="Male")?"M":(createdata.sex=="Female")?"F":"",
                      "citizenID": createdata.citizenID,
                      "emailAddress": createdata.emailAddress,
                      "address1": createdata.address1,
                      "address2": createdata.address2,
                      "city": createdata.city,
                      "county": createdata.county,
                      "postCode": createdata.postCode,
                      "consent1": (objsmstobc.consent1==true)?(objsmstobc.consent1)?"Yes":"No":(objsmstobc.consent1==false)?"No":"",
                      "dateConsent1":(objsmstobc.consent1===undefined )?"0001-01-01":newdate,
                      "consent2": (objsmstobc.consent2==true)?(objsmstobc.consent2)?"Yes":"No":(objsmstobc.consent2==false)?"No":"",
                      "dateConsent2": (objsmstobc.consent2===undefined )?"0001-01-01":newdate,
                      "consent3": (objsmstobc.consent3==true)?(objsmstobc.consent3)?"Yes":"No":(objsmstobc.consent3==false)?"No":"",
                      "dateConsent3": (objsmstobc.consent3===undefined )?"0001-01-01":newdate,
                      "consent4": (objsmstobc.consent4==true)?(objsmstobc.consent4)?"Yes":"No":(objsmstobc.consent4==false)?"No":"",
                      "dateConsent4": (objsmstobc.consent4===undefined )?"0001-01-01":newdate,
                      "consent5": (objsmstobc.consent5==true)?(objsmstobc.consent5)?"Yes":"No":(objsmstobc.consent5==false)?"No":"",
                      "dateConsent5":(objsmstobc.consent5===undefined )?"0001-01-01":newdate,
                      "consent6": (objsmstobc.consent6==true)?(objsmstobc.consent6)?"Yes":"No":(objsmstobc.consent6==false)?"No":"",
                      "dateConsent6":(objsmstobc.consent6===undefined )?"0001-01-01":newdate,
                      "apiStoreRegister": "",
                      //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      referalMobileNo: objsmstobc.referalMobileNo,
                      //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      "blocked": false,//*
                      "dateBlocked": "0001-01-01",
                      "apiType": "UPDATE"
                      });
      }else{

        var datatotfirebase ={
          "address":  createdata.address1,
          "address2": createdata.address2,
          "bc_account_no": createdata.memberAccountNo,
          "club_code": createdata.memberClub,
          "consent1": (String(user.consent1)==="")?"":(user.consent1==true)?true:(user.consent1==false)?false:"",
          "consent1_date": (String(user.consent1)==="")?"0001-01-01":newdate,
          "consent2":(String(user.consent2)==="")?"":(user.consent2==true)?true:(user.consent2==false)?false:"",
          "consent2_date": (String(user.consent2)==="")?"0001-01-01":newdate,
          "consent3": (String(user.consent3)==="")?"":(user.consent3==true)?true:(user.consent3==false)?false:"",
          "consent3_date": (String(user.consent3)==="")?"0001-01-01":newdate,
          "consent4": (String(user.consent4)==="")?"":(user.consent4==true)?true:(user.consent4==false)?false:"",
          "consent4_date": (String(user.consent4)==="")?"0001-01-01":newdate,
          "consent5": (String(user.consent5)==="")?"":(user.consent5==true)?true:(user.consent5==false)?false:"",
          "consent5_date": (String(user.consent5)==="")?"0001-01-01":newdate,
          "consent6":(String(user.consent6)==="")?"":(user.consent6==true)?true:(user.consent6==false)?false:"",
          "consent6_date":  (String(user.consent6)==="")?"0001-01-01":newdate,
          "country": createdata.county,
          "city": createdata.city,
          "date_of_birth": createdata.dateOfBirth,
          "email_address": createdata.emailAddress,
          "first_name": user.first_name,
          "id_card_no": createdata.citizenID,
          "last_name": user.last_name,
          "line_user_id":  linedataconvert,
          "mobile_phone_no": user.mobile_phone_no,
          //AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
          "nearlyExpireDate": createdata.nearlyExpireDate,
          "nearlyExpirePoint": createdata.nearlyExpirePoint,
          //C-AVCDAPNF.005  25/02/2025  Add Code for เพิ่ม field expires date และ expires point
          "post_code": createdata.postCode,
          "scheme": createdata.memberScheme,
          "scheme_code": createdata.memberScheme,
          "sex": createdata.sex,
          "ramianing_point":createdata.totalRemainingPoints,
            "confirmdata":true,
            "checkTamp":false,
        };
        var raw = JSON.stringify({
                      "memberAccountNo": createdata.memberAccountNo,
                      "clubCode": createdata.memberClub,//*
                      "schemeCode": createdata.memberScheme,
                      "mobileNo":  user.mobile_phone_no,//*
                      "lineUserId": linedataconvert, //*
                      "firstName": user.first_name,//*
                      "lastName": user.last_name,//*
                      "dateOfBirth": createdata.dateOfBirth,
                      "sex": (createdata.sex=="Male")?"M":(createdata.sex=="Female")?"F":"",
                      "citizenID": createdata.citizenID,
                      "emailAddress": createdata.emailAddress,
                      "address1": createdata.address1,
                      "address2": createdata.address2,
                      "city": createdata.city,
                      "county": createdata.county,
                      "postCode": createdata.postCode,
                      "consent1": (String(user.consent1)==="")?"":(user.consent1==true)?"Yes":(user.consent1==false)?"No":"",
                      "dateConsent1": (String(user.consent1)==="")?"0001-01-01":newdate,
                      "consent2": (String(user.consent2)==="")?"":(user.consent2==true)?"Yes":(user.consent2==false)?"No":"",
                      "dateConsent2": (String(user.consent2)==="")?"0001-01-01":newdate,
                      "consent3": (String(user.consent3)==="")?"":(user.consent3==true)?"Yes":(user.consent3==false)?"No":"",
                      "dateConsent3": (String(user.consent3)==="")?"0001-01-01":newdate,
                      "consent4": (String(user.consent4)==="")?"":(user.consent4==true)?"Yes":(user.consent4==false)?"No":"",
                      "dateConsent4": (String(user.consent4)==="")?"0001-01-01":newdate,
                      "consent5": (String(user.consent5)==="")?"":(user.consent5==true)?"Yes":(user.consent5==false)?"No":"",
                      "dateConsent5": (String(user.consent5)==="")?"0001-01-01":newdate,
                      "consent6": (String(user.consent6)==="")?"":(user.consent6==true)?"Yes":(user.consent6==false)?"No":"",
                      "dateConsent6": (String(user.consent6)==="")?"0001-01-01":newdate,
                      "apiStoreRegister": "",
                      //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      referalMobileNo: '',
                      //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                      "blocked": false,//*
                      "dateBlocked": "0001-01-01",
                      "apiType": "UPDATE"
                      });
      }
      console.log("rawrawrawraw",raw);

  /*  const datatotfirebase ={
      "address":  createdata.address1,
    //  "address2": createdata.address2,
      "bc_account_no": createdata.memberAccountNo,
      "club_code": createdata.memberClub,
      "consent1": (createdata.consent1=="Yes")?(createdata.consent1)?true:false:(createdata.consent1=="NO")?false:"",
      "consent1_date":createdata.dateConsent1,
      "consent2": (createdata.consent2=="Yes")?(createdata.consent2)?true:false:(createdata.consent2=="NO")?false:"",
      "consent2_date": createdata.dateConsent2,
      "consent3": (createdata.consent3=="Yes")?(createdata.consent3)?true:false:(createdata.consent3=="NO")?false:"",
      "consent3_date": createdata.dateConsent3,
      "consent4": (createdata.consent4=="Yes")?(createdata.consent4)?true:false:(createdata.consent4=="NO")?false:"",
      "consent4_date": createdata.dateConsent4,
      "consent5": (createdata.consent5=="Yes")?(createdata.consent5)?true:false:(createdata.consent5=="NO")?false:"",
      "consent5_date": createdata.dateConsent5,
      "consent6": (createdata.consent6=="Yes")?(createdata.consent6)?true:false:(createdata.consent6=="NO")?false:"",
      "consent6_date": createdata.dateConsent5,
      "country": createdata.county,
      "city": createdata.city,
      "date_of_birth": createdata.dateOfBirth,
      "email_address": createdata.emailAddress,
      "first_name": createdata.memberName,
      "id_card_no": createdata.citizenID,
      "last_name": createdata.memberSurName,
      "line_user_id":  createdata.lineUserId,
      "mobile_phone_no": createdata.mobileNo,
      "post_code": createdata.postCode,
      "scheme": createdata.schemeCode,
      "sex": createdata.sex,
      "ramianing_point":createdata.totalRemainingPoints,
        "confirmdata":true,
    };*/



    const idfirebase=datatotfirebase.club_code+"_"+datatotfirebase.line_user_id;
    const userDoc = doc(db, "Member",idfirebase);
       const newFields =  datatotfirebase;
        updateDoc(userDoc,newFields );

  //  var urlcreate =connectionweb[0].Web_Api_Endpoint+connectionweb[0].Web_Api_Create_Update_Web_Member_Data;
  //  const resp =  axios.post(urlcreate,datatotfirebase,{
  //       headers: {
  //   "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
  //   }
  //   })
  //   .then(resp=>{
      // console.log("return resp",resp);
      // console.log("return raw",raw);
        // saveonbc

        var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Create_Update_Member;
        var myHeadersotpUsage = new Headers();
        myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
        myHeadersotpUsage.append("Content-Type", "application/json");
        fetch(urlotpUsage, {
          method: 'POST',
          headers: myHeadersotpUsage,
          body: raw,
          redirect: 'follow'
        })
        .then(response => response.text())
        .then(data => {
          console.log("resp",data);
        //AVCDAPNF.005 , //AVCDAPNF.006  25/02/2025  Add Code for เพิ่ม field expires date และ expires point และ อัพเดท remaining point
        const createdDataBC = JSON.parse(data)
        console.warn('createdDataBC ', createdDataBC)

        if (!createdDataBC.mobileNo) return

        if (otpsmstobc) {
          var urlLicense = connectionweb[0].BC_Api_Endpoint + connectionweb[0].BC_Api_Get_Member + "?$filter=mobileNo eq '" + objsmstobc.telephone + "' and memberClub eq '" + checkcluburl(clubcodeconvert) + "'"
        } else {
          var urlLicense = connectionweb[0].BC_Api_Endpoint + connectionweb[0].BC_Api_Get_Member + "?$filter=mobileNo eq '" + user.mobile_phone_no + "' and memberClub eq '" + checkcluburl(clubcodeconvert) + "'"
        }

        var myHeaders = new Headers()
        myHeaders.append( 'Authorization', authenticateUser(connectionweb[0].BC_Api_Username, connectionweb[0].BC_Api_Password))


        fetch(urlLicense, {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow',
        })
          .then((response) => response.text())
          .then((data) => {
            const memberDataFromBC = JSON.parse(data)
            const memberData = memberDataFromBC.value[0]
            const idfirebase = datatotfirebase.club_code + '_' + datatotfirebase.line_user_id
            const userDoc = doc(db, 'Member', idfirebase)
            const newFields = {
              ...datatotfirebase,
              //AVCDAPNF.005  25/02/2025  Add code for   เพิ่ม field expires date และ expires point
              nearlyExpireDate: memberData.nearlyExpireDate,
              nearlyExpirePoint: memberData.nearlyExpirePoint,
              //C-AVCDAPNF.005  25/02/2025  Add code for   เพิ่ม field expires date และ expires point
              //AVCDAPNF.006  25/02/2025  Add Code for อัพเดท remaining point
              ramianing_point: memberData.totalRemainingPoints,
              //C-AVCDAPNF.006  25/02/2025  Add Code for อัพเดท remaining point
            }
            updateDoc(userDoc, newFields)

            window.sessionStorage.setItem('Confirmdata', 'Yes')
            setIsOpenLoading(false)
            sessionStorage.setItem('Customerdata', JSON.stringify(newFields))
            console.log('dd', datatotfirebase)

            //   navigate('/login');

            //AVCDAPNF.002  24/02/2025  Add Code for navigate ไปหน้า homepage
            navigate('/homepage')
            //C-AVCDAPNF.002  24/02/2025  Add Code for navigate ไปหน้า homepage
          })
          .catch((error) => {
            console.error('Error confirm: ', error)
          })
        //C-AVCDAPNF.005 , //C-AVCDAPNF.006  25/02/2025  Add Code for เพิ่ม field expires date และ expires point และ อัพเดท remaining point
        })
        .catch(err=> console.log(err))
        //saveonbc


    // })
    // .catch(err=> console.log(err))
     //send save data firebase


  }
  const [ phone, setphone ] = useState<string>();
  const [ name, setname ] = useState<string>();
  const [ confrimdata, setconfrimdata ] = useState<string>();
  const [ title, settitle ] = useState<string>();
  const [smsref, setsmsref] = useState<String>();
  const [smsphone, setsmsphone] = useState<String>();
  const [confirmdatasuc, setconfirmdatasuc] = useState<String>();


  useEffect(() => {
    const getAllData = async () => {
      // await updatadata()
      await checkcustomer();
      await setfileconfig();
    };
      getAllData();
  //  fetchLiff()
  // checkcustomerlogin();

//  updatadata();
  }, [])
  const [logoImageweb, setLogoImageweb] = useState('');
async function setfileconfig() {
    const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
    const storageRef_logoweb = ref_storage(storage, setupwebdefault.club_logo_path);
    getDownloadURL(storageRef_logoweb).then((url) => {
      // console.log(url);
      setLogoImageweb(url)
    });
}
  function authenticateUser(user:string, password:string)
  {
      var token = user + ":" + password;
      var hash = btoa(token);
      return "Basic " + hash;
  }
  async function checkcustomer() {
    // confirmdata
    let clubcode = window.sessionStorage.getItem('Club_Code');
    let clubcodeconvert =""+clubcode;
    let linedata = window.sessionStorage.getItem('linedata');
    let linedataconvert =""+linedata;
    let otpsms = window.sessionStorage.getItem('OTPSMS');
    let otpsmsconvert= ""+otpsms;
    const objsms = JSON.parse(otpsmsconvert);
    const user = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
     if (otpsms) {
          var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=mobileNo eq '"+objsms.telephone+"' and memberClub eq '"+checkcluburl(clubcodeconvert)+"'";

      }else{
          var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Get_Member+"?$filter=mobileNo eq '"+user.mobile_phone_no+"' and memberClub eq '"+checkcluburl(clubcodeconvert)+"'";

        }


          let checkedremain ="";
        //  console.log("urlLicense",urlLicense);

          var myHeaders = new Headers();
          myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
        //  myHeaders.append("Content-Type", "application/json");

          fetch(urlLicense, {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
          })
        .then(response => response.text())
        .then(data => {


          setconfirmdatasuc(data)
          const databc = JSON.parse(data);
        //  console.log("ff",databc);

          if (databc.value[0]!=null) {
            setphone(databc.value[0].mobileNo);
            const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
          //  console.log(setupwebdefault);

            if (setupwebdefault.confirm_member_data_type=="ID Card No.") {
              setconfrimdata(databc.value[0].citizenID)
              settitle("รหัสบัตรประชาชน")
            }else if(setupwebdefault.confirm_member_data_type=="E-Mail") {
              setconfrimdata(databc.value[0].emailAddress)
              settitle("Email")
            }else if(setupwebdefault.confirm_member_data_type=="Name") {
              setconfrimdata(databc.value[0].firstName+"   "+databc.value[0].lastName)
              settitle("ชื่อ-นามสกุล")
            }
          }else{
            console.log("null");
          }



        })
        .catch(error => console.log('error', error));


  }
  console.log("confirmdatasuc",confirmdatasuc);
  let stylesweb = JSON.parse(""+window.sessionStorage.getItem('stylesetup'));

  const styles = {
    title_style: {
      "backgroundColor": stylesweb.title_style.background_color,
      "border": stylesweb.title_style.border,
      "border-color": stylesweb.title_style.border_color,
      "border-radius":stylesweb.title_style.border_radius,
      "color": stylesweb.title_style.font_color,
      "font-family": stylesweb.title_style.font_name,
      "font-size": stylesweb.title_style.font_size,
      "font-weight": stylesweb.title_style.font_weight,
    },
    title2_style: {
      "backgroundColor": stylesweb.title2_style.background_color,
      "border": stylesweb.title2_style.border,
      "border-color": stylesweb.title2_style.border_color,
      "border-radius":stylesweb.title2_style.border_radius,
      "color": stylesweb.title2_style.font_color,
      "font-family": stylesweb.title2_style.font_name,
      "font-size": stylesweb.title2_style.font_size,
      "font-weight": stylesweb.title2_style.font_weight,
    },
    caption_style: {
      "backgroundColor": stylesweb.caption_style.background_color,
      "border": stylesweb.caption_style.border,
      "border-color": stylesweb.caption_style.border_color,
      "border-radius":stylesweb.caption_style.border_radius,
      "color": stylesweb.caption_style.font_color,
      "font-family": stylesweb.caption_style.font_name,
      "font-size": stylesweb.caption_style.font_size,
      "font-weight": stylesweb.caption_style.font_weight,
    },
    input_data_style: {
      "backgroundColor": stylesweb.input_data_style.background_color,
      "border": stylesweb.input_data_style.border,
      "border-color": stylesweb.input_data_style.border_color,
      "border-radius":stylesweb.input_data_style.border_radius,
      "color": stylesweb.input_data_style.font_color,
      "font-family": stylesweb.input_data_style.font_name,
      "font-size": stylesweb.input_data_style.font_size,
      "font-weight": stylesweb.input_data_style.font_weight,
    },
    title_consent_style: {
      "backgroundColor": stylesweb.title_consent_style.background_color,
      "border": stylesweb.title_consent_style.border,
      "border-color": stylesweb.title_consent_style.border_color,
      "border-radius":stylesweb.title_consent_style.border_radius,
      "color": stylesweb.title_consent_style.font_color,
      "font-family": stylesweb.title_consent_style.font_name,
      "font-size": stylesweb.title_consent_style.font_size,
      "font-weight": stylesweb.title_consent_style.font_weight,
    },
    description_consent_style: {
      "backgroundColor": stylesweb.description_consent_style.background_color,
      "border": stylesweb.description_consent_style.border,
      "border-color": stylesweb.description_consent_style.border_color,
      "border-radius":stylesweb.description_consent_style.border_radius,
      "color": stylesweb.description_consent_style.font_color,
      "font-family": stylesweb.description_consent_style.font_name,
      "font-size": stylesweb.description_consent_style.font_size,
      "font-weight": stylesweb.description_consent_style.font_weight,
    },
    consent_page_style_body: {
      "backgroundColor": stylesweb.consent_page_style.background_color,
      "border": stylesweb.consent_page_style.border,
      "border-color": stylesweb.consent_page_style.border_color,
      "color": stylesweb.consent_page_style.font_color,
      "font-family": stylesweb.consent_page_style.font_name,
      "font-size": stylesweb.consent_page_style.font_size,
      "font-weight": stylesweb.consent_page_style.font_weight,
    },
    consent_page_style_header: {
      "backgroundColor": stylesweb.consent_page_style.background_color,
      "border": stylesweb.consent_page_style.border,
      "border-color": stylesweb.consent_page_style.border_color,
      "border-top-left-radius": stylesweb.consent_page_style.border_radius,
      "border-top-right-radius": stylesweb.consent_page_style.border_radius,
      "color": stylesweb.consent_page_style.font_color,
      "font-family": stylesweb.consent_page_style.font_name,
      "font-size": stylesweb.consent_page_style.font_size,
      "font-weight": stylesweb.consent_page_style.font_weight,
    },
    consent_page_style_footer: {
      "backgroundColor": stylesweb.consent_page_style.background_color,
      "border": stylesweb.consent_page_style.border,
      "border-color": stylesweb.consent_page_style.border_color,
      "border-bottom-left-radius": stylesweb.consent_page_style.border_radius,
      "border-bottom-right-radius": stylesweb.consent_page_style.border_radius,
      "color": stylesweb.consent_page_style.font_color,
      "font-family": stylesweb.consent_page_style.font_name,
      "font-size": stylesweb.consent_page_style.font_size,
      "font-weight": stylesweb.consent_page_style.font_weight,
    },

    error_message_box_style: {
      "backgroundColor": stylesweb.error_message_box_style.background_color,
      "border": stylesweb.error_message_box_style.border,
      "border-color": stylesweb.error_message_box_style.border_color,
      "border-radius": stylesweb.error_message_box_style.border_radius,
      "color": stylesweb.error_message_box_style.font_color,
      "font-family": stylesweb.error_message_box_style.font_name,
      "font-size": stylesweb.error_message_box_style.font_size,
      "font-weight": stylesweb.error_message_box_style.font_weight,
    },
    foreground_Style: {
      "backgroundColor": stylesweb.foreground_Style.background_color,
      "border": stylesweb.foreground_Style.border,
      "border-color": stylesweb.foreground_Style.border_color,
      "border-radius": stylesweb.foreground_Style.border_radius,
      "color": stylesweb.foreground_Style.font_color,
      "font-family": stylesweb.foreground_Style.font_name,
      "font-size": stylesweb.foreground_Style.font_size,
      "font-weight": stylesweb.foreground_Style.font_weight,
    },
    background_Style: {
      "backgroundColor": stylesweb.background_Style.background_color,
      "border": stylesweb.background_Style.border,
      "border-color": stylesweb.background_Style.border_color,
      "border-radius": stylesweb.background_Style.border_radius,
      "color": stylesweb.background_Style.font_color,
      "font-family": stylesweb.background_Style.font_name,
      "font-size": stylesweb.background_Style.font_size,
      "font-weight": stylesweb.background_Style.font_weight,
    },
    //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
    cancel_button_style: {
      "backgroundColor": stylesweb.cancel_button_style.background_color,
      "border": stylesweb.cancel_button_style.border,
      "border-color": stylesweb.cancel_button_style.border_color,
      "border-radius": stylesweb.cancel_button_style.border_radius,
      "color": stylesweb.cancel_button_style.font_color,
      "font-family": stylesweb.cancel_button_style.font_name,
      "font-size": stylesweb.cancel_button_style.font_size,
      "font-weight": stylesweb.cancel_button_style.font_weight,
    },
    confirm_button_style: {
      "backgroundColor": stylesweb.confirm_button_style.background_color,
      "border": stylesweb.confirm_button_style.border,
      "border-color": stylesweb.confirm_button_style.border_color,
      "border-radius": stylesweb.confirm_button_style.border_radius,
      "color": stylesweb.confirm_button_style.font_color,
      "font-family": stylesweb.confirm_button_style.font_name,
      "font-size": stylesweb.confirm_button_style.font_size,
      "font-weight": stylesweb.confirm_button_style.font_weight,
    },
    //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style

  };


  	return (


      <div className='card'>
      {/* begin::Form */}

      <div className='row mb-8 imagelogo' style={styles.background_Style}>
      <img src={logoImageweb} alt="metronic"/>
      </div>
        <form className='form d-flex flex-center'   >
          <div className='card-body mw-800px py-20 card-body-editemember' style={styles.foreground_Style}>

            <div className='row mb-8'>
            <label className='card-label fw-bolder fs-3 mb-1 col-form-label editemember-header-label' style={styles.title_style}>ยืนยันข้อมูลสมาชิก</label>
            </div>

            {/* begin::Form row */}
            <div className='row mb-8'>
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>เบอร์โทรศัพท์*</label>
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input disabled
                    className='form-control form-control-lg form-control-solid '
                    type='text'
                    value={phone}
                    style={styles.input_data_style}
                  />
                </div>
              </div>
            </div>
            {/* end::Form row */}
            {/* begin::Form row */}
            <div className='row mb-8'>
              <label className='col-lg-3 col-form-label' style={styles.caption_style}>{title}*</label>
              <div className='col-lg-9'>
                <div className='spinner spinner-sm spinner-primary spinner-right'>
                  <input disabled
                    className='form-control form-control-lg form-control-solid '
                    type='text'
                    value={confrimdata}
                    style={styles.input_data_style}
                  />
                </div>
              </div>
            </div>
            {/* end::Form row */}
            <div className='row mb-8'>
            <label className='card-label fw-bolder fs-3 mb-1 col-form-label block-label-confirmdata'>ใช่ข้อมูลของท่านหรือไม่ ?</label>
            </div>

            {/* begin::Form row */}
            <div className='row confirmdata'>
              <label className='col-lg-3 col-form-label'></label>
              <div className='col-lg-9'>
                <button type='reset' 
                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                style={styles.cancel_button_style}
                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                onClick={() => handleClickNotconfirm() } className='btncancleconfirm editemember btn btn-primary fw-bolder px-6 py-3 me-3'>
                  ไม่ถูกต้อง
                </button>
                <button type='reset' 
                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                style={styles.confirm_button_style}
                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                onClick={() => handleClickconfirm() }  className='btnconfirm editemember btn btn-primary fw-bolder px-6 py-3 me-3'>
                  ยืนยัน
                </button>

              </div>
            </div>
            {/* end::Form row */}

          </div>
        </form>
        {/* end::Form */}

        {isOpenLoading && <Popup
          content={<>
              <div className="box" style={styles.error_message_box_style}>
              <h2>Loading....</h2>
              <img src={loadingicon} alt="success" className="img-correct loading-icon"/>


        </div>
          </>}

        />}
      </div>
  	)
}
